import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface ReportItemsOnHireSummary {
    loading: boolean;
    errors: string;
}


export class ReportItemsOnHireSummaryData extends React.Component<RouteComponentProps<{}>, ReportItemsOnHireSummary> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            errors: ""
        } 
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                this.setState({ loading: false });
            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data
        this.runRpt(); 
    }

    async runRpt() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        axios('api/Report/RunItemsOnHireSummaryReport?subId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Items On Hire Summary.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <div>
                <div>
                    <h1>Items On Hire Summary Report</h1>
                </div>
                <div>
                    <button className="defaultbutton" type='button' onClick={this.runReport}>Run Report</button>
                </div>
            </div>
        );

    }

};